import script from "./genuine-software.vue?vue&type=script&lang=ts&setup=true"
export * from "./genuine-software.vue?vue&type=script&lang=ts&setup=true"

import "./genuine-software.vue?vue&type=style&index=0&id=6d12f481&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d12f481"]])

export default __exports__